import {
  ArrowDownward,
  DeleteForever,
  More,
  MoreHoriz,
  RemoveCircle,
} from "@material-ui/icons";
import React, { useState, useEffect, ChangeEvent } from "react";
import { useSelector, useDispatch } from "react-redux";
import apis from "../../api/apis";
import { API_INTEGRATION_ID } from "../../config";
import { IBaseModel } from "../../interfaces/base";
import { IPartnerMenuItem } from "../../interfaces/menu";
import ItemCard from "./components/ItemCard/ItemCard";
import styles from "./Sales.module.scss";
import { Add, Remove } from "@material-ui/icons";
import LoadingComponent from "../loadingComponent/LoadingComponent";
import { Link, useHistory } from "react-router-dom";
import { addSalesItems } from "../../redux/actions/sales/sales";
import { PersonAddAlt, Preview } from "@mui/icons-material";
import RegisterCustomer from "./components/registerCustomer/RegisterCustomer";
import {
  addTicket,
  reduceQuantity,
  removeItem,
  resetTickets,
  setTotal,
  setDiscountType,
  setDiscountAmount,
} from "../../redux/actions/tickets/tickets";
import { cus_data } from "./components/registerCustomer/data";
import ScrollMenu from "./components/scrollMenu/ScrollMenu";
import PreviousSales from "./components/previousSales/PreviousSales";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import DiscountModel from "./components/DiscountModel/DiscountModel";
import ItemDiscount from "./components/ItemDiscount/ItemDiscount";
import ReceiptJournal from "./components/ReceiptJournalModel/ReceiptJournal";
import HoldTransaction from "./components/HoldTransaction/HoldTransaction";

const Sales = () => {
  const [loading, setloading] = useState<boolean>(false);
  const [toggleRegister, settoggleRegister] = useState<boolean>(false);
  //const [items, setitems] = useState<IPartnerMenuItem[]>();
  const [category, setcategory] = useState<any>([]);

  const [searchQuery, setsearchQuery] = useState("");
  const [categoryFilter, setcategoryFilter] = useState<string>();

  const [selected, setselected] = useState(-1);
  const [selectOrderType, setSelectOrderType] = useState("");

  //model states
  const [showPreviousSales, setshowPreviousSales] = useState(false);
  const [showDiscount, setshowDiscount] = useState(false);
  const [showItemDiscount, setshowItemDiscount] = useState(false);
  const [showReceiptJournal, setShowReceiptJournal] = useState(false);
  const [showHoldSale, setShowHoldSale] = useState(false);

  //dispatch
  const dispatch = useDispatch();
  const history = useHistory();

  //user
  const { user } = useSelector((state: any) => state.authentication);
  //console.log(user);
  const { isAllMenuLoading, menuItems, isMenuLoaded, error } = useSelector(
    (state: any) => state.getAllMenuReducer
  );
  //console.log(menuItems);
  //console.log(isAllMenuLoading);
  // console.log(isMenuLoaded);
  // console.log(error);

  const { ticketItems, total, orderType, discountAmount, discountType } =
    useSelector((state: any) => state.ticketReducer);

  //console.log(ticketItems);

  const getItems = async () => {
    setloading(true);
    const data: IBaseModel = {
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };

    const { ResponseData } = await apis.Menus.getMenuItemList(data);
    // setitems(ResponseData.MenuItemList.slice(0, 20));

    //CategoryName

    const categoryName = ResponseData.MenuItemList.map(
      (item: IPartnerMenuItem) => item.CategoryName
    );
    //console.log(categoryName);

    const newCategory = Array.from(new Set(categoryName));
    setcategory(newCategory);
    //console.log(newCategory);

    setloading(false);
    setcategoryFilter(category[0]);
  };

  useEffect(() => {
    //  getItems();
    // history.push("/sales");
  }, []);

  useEffect(() => {
    // console.log("rendered");
    totalSum();
  }, [ticketItems]);

  useEffect(() => {
    if (category.length > 0) {
      setcategoryFilter(category[0]);
      setselected(0);
    }
  }, [category]);

  useEffect(() => {
    if (isMenuLoaded) {
      const categoryName = menuItems.map(
        (item: IPartnerMenuItem) => item.CategoryName
      );
      //console.log(categoryName);

      const newCategory = Array.from(new Set(categoryName));
      setcategory(newCategory);
    }
  }, [isMenuLoaded, menuItems]);

  const addToTicket = (item: IPartnerMenuItem) => {
    const newItem = {
      ItemName: item.ItemName,
      ItemCode: item.ItemCode,
      ItemPrice: item.SalesPrice,
      // ItemQuantity: 1,
    };

    dispatch(addTicket(newItem));

    // if (tickets.length === 0) {

    //   settickets([...tickets, newItem]);
    // } else {

    //   tickets.some((prevState: any) => prevState.ItemCode === item.ItemCode)
    //     ? settickets((prevTickets: any) =>
    //         prevTickets.map((singleItem: any) =>
    //           singleItem.ItemCode === item.ItemCode
    //             ? { ...singleItem, ItemQuantity: singleItem.ItemQuantity + 1 }
    //             : singleItem
    //         )
    //       )
    //     : settickets([...tickets, newItem]);
    // }
  };

  // const handleQuantity = (action: string, item: any) => {
  //   console.log("item");
  //   console.log(item);
  //   if (action === "add") {
  //     console.log("add");
  //     settickets((prevTickets: any) =>
  //       prevTickets.map((singleItem: any) =>
  //         singleItem.ItemCode === item.ItemCode
  //           ? { ...singleItem, ItemQuantity: singleItem.ItemQuantity + 1 }
  //           : singleItem
  //       )
  //     );
  //   } else if (action === "remove") {
  //     console.log("remove");
  //     settickets([...tickets]);
  //     if (item.ItemQuantity <= 1) {
  //       console.log("remove: " + item.ItemQuantity);
  //       const filtered = tickets.filter(
  //         (singleItem: any) => singleItem.ItemCode !== item.ItemCode
  //       );

  //       settickets(filtered);
  //     } else {
  //       settickets((prevTickets: any) =>
  //         prevTickets.map((singleItem: any) =>
  //           singleItem.ItemCode === item.ItemCode
  //             ? { ...singleItem, ItemQuantity: singleItem.ItemQuantity - 1 }
  //             : singleItem
  //         )
  //       );
  //     }
  //   }
  // };

  //search filter
  const handleSearch = (event: any) => {
    const { value } = event.target;
    setsearchQuery(value);
  };

  const handleCategoryFilter = (event: any) => {
    const { value } = event.target;
    setcategoryFilter(value);
  };

  const totalSum = () => {
    var sum = 0;
    ticketItems &&
      ticketItems.forEach(function (item: any) {
        sum += item.ItemPrice * item.ItemQuantity;
      });
    return sum.toFixed(2);
  };

  const proceedToPaymentHandler = () => {
    //  dispatch(addSalesItems(tickets));
    dispatch(setTotal(totalSum()));
  };

  if (isAllMenuLoading) {
    return (
      <div>
        <LoadingComponent />
      </div>
    );
  }

  // console.log(parseInt(totalSum()));
  return (
    <div className={styles.sales_container}>
      {showDiscount && (
        <DiscountModel
          handleCancelDiscount={() => {
            setshowDiscount(false);
            dispatch(setDiscountType(""));
          }}
          setAndClose={() => setshowDiscount(false)}
        />
      )}
      {showItemDiscount && (
        <ItemDiscount
          handleCancelDiscount={() => {
            //dispatch

            setshowItemDiscount(false);
          }}
          setAndClose={() => setshowItemDiscount(false)}
        />
      )}

      {showReceiptJournal && (
        <ReceiptJournal closeModel={() => setShowReceiptJournal(false)} />
      )}
      {showHoldSale && (
        <HoldTransaction closeModel={() => setShowHoldSale(false)} />
      )}
      <div className={styles.item_list}>
        <ScrollMenu
          category={category}
          handleCategoryFilter={handleCategoryFilter}
          handleSearch={handleSearch}
          loading={loading}
        />

        <div className={styles.item_list_body}>
          {/* <div className={styles.button_options}>
            <button onClick={() => dispatch(resetTickets())}>Void sale</button>
            <button onClick={() => setshowPreviousSales(true)}>
              Previous sales
            </button>
            <button
              onClick={() => {
                setshowDiscount(true);
              }}
            >
              Total discount
            </button>
            <button
              onClick={() => {
                setshowItemDiscount(true);
              }}
            >
              Item discount
            </button>
            <button onClick={() => setShowHoldSale(true)}>Hold sale</button>
            
            <button
              onClick={() => {
                setShowReceiptJournal(true);
              }}
            >
              Recipt journal
            </button>
        
          </div> */}

          <div className={styles.item_card}>
            {isAllMenuLoading === false &&
            searchQuery === "" &&
            categoryFilter === "all"
              ? menuItems?.map((item: IPartnerMenuItem) => (
                  <ItemCard item={item} onTap={() => addToTicket(item)} />
                ))
              : categoryFilter !== "all" && searchQuery === ""
              ? menuItems
                  ?.filter(
                    (singleItem: any) =>
                      singleItem.CategoryName === categoryFilter
                  )
                  .map((item: IPartnerMenuItem) => (
                    <ItemCard item={item} onTap={() => addToTicket(item)} />
                  ))
              : menuItems
                  ?.filter(
                    (singleItem: any) =>
                      singleItem.ItemName.toLowerCase().includes(searchQuery) ||
                      singleItem.ItemCode === searchQuery
                  )
                  .map((item: IPartnerMenuItem) => (
                    <ItemCard item={item} onTap={() => addToTicket(item)} />
                  ))}
          </div>
        </div>
      </div>

      {/* right section */}
      <div className={styles.sales_ticket}>
        <div className={styles.customer}>
          <FormControl
            sx={{
              m: 1,
              minWidth: 200,
            }}
          >
            <InputLabel id="demo-simple-select-helper-label">
              Order Type
            </InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={selectOrderType}
              label="Walk In"
              onChange={(e: any) => setSelectOrderType(e.target.value)}
            >
              <MenuItem value={"walkIn"}>Walk in/Pick up</MenuItem>

              <MenuItem value={"delivery"}>Delivery</MenuItem>
              <MenuItem value={"phoneOrder"}>Phone Order</MenuItem>
              {/* <MenuItem value={30}>Thirty</MenuItem> */}
            </Select>
          </FormControl>
          <PersonAddAlt onClick={() => settoggleRegister(true)} />
        </div>
        <div className={styles.ticket_items}>
          <div className={styles.ticket_header}>
            <div className={styles.header_item}>
              <span>Item</span>
            </div>

            <div className={styles.header_quantity}>
              <span>Quantity</span>
            </div>

            <div className={styles.header_unit_price}>
              <span>Unit price</span>
            </div>

            <div className={styles.header_total_price}>
              <span>Total price</span>
            </div>
          </div>
          {ticketItems.length > 0 ? (
            ticketItems.map((item: any) => (
              <div className={styles.ticket_item}>
                <div className={styles.item_name}>
                  <span>{item.ItemName}</span>
                </div>

                <div className={styles.counter}>
                  <button onClick={() => dispatch(reduceQuantity(item))}>
                    <Remove />
                  </button>
                  <span className={styles.item_qty}>{item.ItemQuantity}</span>
                  <button onClick={() => dispatch(addTicket(item))}>
                    <Add />
                  </button>
                </div>
                <div className={styles.unit_container}>
                  <span>{item.ItemPrice.toFixed(2)}</span>
                </div>
                <div className={styles.total_container}>
                  <span>{(item.ItemQuantity * item.ItemPrice).toFixed(2)}</span>
                  <DeleteForever
                    style={{ color: "#4097ff", cursor: "pointer" }}
                    onClick={() => {
                      dispatch(removeItem(item.ItemCode));
                      // window.alert(item.ItemCode);
                    }}
                  />
                </div>
              </div>
            ))
          ) : (
            <span>Please add items</span>
          )}
        </div>

        {ticketItems.length > 0 && (
          <>
            <div className={styles.ticket_total}>
              {/* <span>Rs.10000</span> */}
              <div className={styles.sub_total}>
                <span>Sub Total :</span>
                <span>Rs. {totalSum()}</span>
              </div>
              {discountType !== "" ? (
                <div className={styles.discount}>
                  <span>Discount :</span>
                  {discountType === "Amount" ? (
                    <span>{discountAmount.toFixed(2)}</span>
                  ) : (
                    <span>
                      {(Number(totalSum()) * discountAmount).toFixed(2)}
                    </span>
                  )}
                  {/* <span>{discountAmount}</span> */}
                </div>
              ) : (
                <div className={styles.discount}>
                  <span>Discount :</span>
                  <span>-</span>
                </div>
              )}

              <div className={styles.net_total}>
                {discountType === "" ? (
                  <>
                    <span>Net Total :</span>
                    <span>{totalSum()}</span>
                  </>
                ) : (
                  <>
                    <span>Net Total :</span>
                    {discountType === "Amount" ? (
                      <span>
                        {(
                          Number(totalSum()) - discountAmount.toFixed(2)
                        ).toFixed(2)}
                      </span>
                    ) : (
                      <span>
                        {(
                          Number(totalSum()) -
                          Number(totalSum()) * discountAmount
                        ).toFixed(2)}
                      </span>
                    )}
                    {/* <span>{parseInt(totalSum()) - discountAmount}</span> */}
                  </>
                )}
              </div>
            </div>

            <div className={styles.button_container}>
              <div className={styles.static_button}>
                <Link to="/sales/checkout">
                  <button onClick={proceedToPaymentHandler}>
                    Proceed to payment
                  </button>
                </Link>
              </div>

              <div className={styles.scroll_buttons}>
                <button onClick={() => dispatch(resetTickets())}>
                  Void sale
                </button>
                <button onClick={() => setshowPreviousSales(true)}>
                  Previous sales
                </button>
                <button
                  onClick={() => {
                    setshowDiscount(true);
                  }}
                >
                  Total discount
                </button>
                <button
                  onClick={() => {
                    setshowItemDiscount(true);
                  }}
                >
                  Item discount
                </button>
                <button onClick={() => setShowHoldSale(true)}>Hold sale</button>
                {/* <button onClick={() => {}}>Credit management</button>{" "}
            <button onClick={() => {}}>Dashboard</button>{" "} */}
                <button
                  onClick={() => {
                    setShowReceiptJournal(true);
                  }}
                >
                  Recipt journal
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      {toggleRegister && (
        <RegisterCustomer
          onClick={() => settoggleRegister(false)}
          customerList={cus_data}
        />
      )}

      {showPreviousSales && (
        <PreviousSales onClose={() => setshowPreviousSales(false)} />
      )}
    </div>
  );
};

export default Sales;
